import { NUM_BAR, NUM_VAR, clamp } from '../constants';

export interface Layout {
  cssWidth: number;
  cssHeight: number;
  side: number;
  originX: number;
  originY: number;
  cellPx: number;
  buttonPx: number;
  buttonInset: number;
  // hit-zone strips (iOS-style): full-height left/right 12.5% bands, split at y=0.5.
  zoneLeft: number;
  zoneRight: number;
  zoneSplit: number;
}

const GRID_SCALE = 0.85;
// Buttons proportional to grid side, with generous floor for touch targets.
// Phones in landscape end up around 60-72 px; desktops cap at 128 px.
const BUTTON_BASE = 0.13;
const BUTTON_INSET = 16;

export function computeLayout(cssWidth: number, cssHeight: number): Layout {
  const side = Math.floor(Math.min(cssWidth, cssHeight) * GRID_SCALE);
  const cellPx = side / NUM_BAR;
  const originX = Math.floor((cssWidth - side) / 2);
  const originY = Math.floor((cssHeight - side) / 2);
  const buttonPx = Math.floor(clamp(side * BUTTON_BASE, 56, 128));
  return {
    cssWidth,
    cssHeight,
    side,
    originX,
    originY,
    cellPx,
    buttonPx,
    buttonInset: BUTTON_INSET,
    zoneLeft: cssWidth * 0.125,
    zoneRight: cssWidth * 0.875,
    zoneSplit: cssHeight * 0.5,
  };
}

export function gridCellAt(x: number, y: number, layout: Layout): { bar: number; varIdx: number } | null {
  if (x < layout.originX || y < layout.originY) return null;
  if (x >= layout.originX + layout.side || y >= layout.originY + layout.side) return null;
  const bar = clamp(Math.floor((x - layout.originX) / layout.cellPx), 0, NUM_BAR - 1);
  const varIdx = clamp(Math.floor((y - layout.originY) / layout.cellPx), 0, NUM_VAR - 1);
  return { bar, varIdx };
}

export function cellCenter(bar: number, varIdx: number, layout: Layout): { x: number; y: number } {
  return {
    x: layout.originX + bar * layout.cellPx + layout.cellPx / 2,
    y: layout.originY + varIdx * layout.cellPx + layout.cellPx / 2,
  };
}
